import React from 'react';
import FAQAccordion from './FAQAccordion';
import { MessageCircle } from 'lucide-react';
import { faqData } from '../../data/faqData';

const FAQSection = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-white to-[#9a6ebd]/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#9a6ebd]/10 rounded-full mb-4">
            <MessageCircle className="w-8 h-8 text-[#9a6ebd]" />
          </div>
          <h2 className="text-3xl font-bold text-[#323c5f]">
            Questions Fréquentes
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-2xl mx-auto">
            Vous avez des questions ? Nous avons les réponses !
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {Object.entries(faqData).map(([key, section]) => (
            <div key={key} className="bg-white rounded-2xl shadow-lg p-6 border-2 border-[#ceace8] hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-[#323c5f] mb-6 pb-4 border-b border-[#9a6ebd]/20">
                {section.title}
              </h3>
              <FAQAccordion questions={section.questions} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;